import { Col } from 'antd';
import styled from 'styled-components';

export interface BoxProps {
    readonly bg?: boolean;
}

 export const BoxQ = styled(Col)<BoxProps>`
  background: ${(props) => props.bg ? "#75706B" : "white"};
  display: flex;
  flex-direction:column;
  
`

// export const Box3D = (props:ColProps) => {
//     return (
//         <>
//             <Box style={(props.style)}>
//                 {props.children}
//             </Box>
//         </>
//     );
// }
